import React, { Component } from 'react';


class Share extends Component {

    shareFacebook(e) {

        e.preventDefault();
        const FB = window.FB;

        FB.ui(
            {
                method: 'share',
                href: 'http://games.sambal.be/renaatsoundboard/share.html'
            },
            // callback
            function(response) {
            }
        );
    }

    shareTwitter(e) {
        e.preventDefault();

        let text = 'Tijd voor een snelcursus wieleritaliaans van @wielerman!';
        let url = 'http://sporza.be/permalink/1.2969412';

        window.open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&hashtags=renaat&url=${url}`, 'tweet', 'width=400,height=300');
    }

    render() {

        return <div>
            <div className="share-buttons">
                <a href="#" className="btn btn-facebook" onClick={this.shareFacebook.bind(this)}>Deel op Facebook</a>
                <a href="#" className="btn btn-twitter" onClick={this.shareTwitter.bind(this)}>Deel op Twitter</a>
            </div>
        </div>
    }
}

export default Share;



// WEBPACK FOOTER //
// ./src/Share.js